import request, { IServerResponse } from '@/utils/request';
import { SignState, IGetSettlementRuleByPeriodReq, IGetSettlementRuleByPeriodRes } from './define';

interface SignReq {
    providerId: number;
    distributeId: string;
    data: any;
}

interface WithdrawReq {
    providerId: number;
    distributeId: string;
}

interface OrderIdRes {
    orderTime: number;
    orderViewId: string;
}

// 获取签约状态（筛选项）列表
export const getSignStateList = (): Promise<IServerResponse<SignState>> =>
    request.get('/api/thirdpartnar/sign/status/list');

export const getOrderId = (distributeId: string): Promise<IServerResponse<OrderIdRes>> =>
    request.get('/api/thirdpartnar/sign/record/signed/order', { distributeId });

export const postSign = ({
    providerId,
    distributeId,
    data,
}: SignReq): Promise<IServerResponse<string>> =>
    request.post(
        '/api/thirdpartnar/sign/confirm',
        {
            providerId,
            distributeId,
            ...data,
        },
        {
            headers: { 'Content-Type': 'application/json' },
        },
    );

export const postSignNoToast = ({
    providerId,
    distributeId,
    data,
}: SignReq): Promise<IServerResponse<string>> =>
    request.post(
        '/api/thirdpartnar/sign/confirm',
        {
            providerId,
            distributeId,
            ...data,
        },
        { headers: { 'Content-Type': 'application/json' } },
        false,
    );

export const postWithdrowNoToast = ({
    providerId,
    distributeId,
}: WithdrawReq): Promise<IServerResponse<string>> =>
    request.post(
        '/api/thirdpartnar/sign/withdraw',
        {
            providerId,
            distributeId,
        },
        {},
        false,
    );

// 获取该合作模式可签约的周期列表
export const getSelectablePeriod = (params: {
    [key: string]: number;
}): Promise<IServerResponse<string[]>> =>
    request.get('/api/thirdpartnar/sign/selectable/periods', params);

// 获取该合作模式在签约发起时展示的结算规则
// export const getSettlementRule = (params: {
//     [key: string]: number;
// }): Promise<IServerResponse<{ [key: string]: string } & { isComplete: boolean }>> =>
//     request.get('/api/thirdpartnar/sign/settlement/rule', params);

// 根据服务周期匹配结算规则
export const getSettlementRuleByPeriod = (
    params: IGetSettlementRuleByPeriodReq,
): Promise<IServerResponse<IGetSettlementRuleByPeriodRes>> =>
    request.get('/api/thirdpartnar/sign/period/matched/poi/settlement/rule', params);
